/**
 * Notify dispatcher of given view actions.
 */
import redirect from 'js/lib/coursera.redirect';

import AuthoringPartnerAPIUtils from 'bundles/author-partner/utils/AuthoringPartnerAPIUtils';
import { getMyAdmins } from 'bundles/common/api/adminAPIUtils';

import type { PartnerTypeValuesType } from '../constants/PartnerType';

export const createNewPartner = (
  actionContext: $TSFixMe,
  {
    name,
    shortName,
    abbrName,
    partnerType,
  }: {
    name: string;
    shortName: string;
    abbrName: string;
    partnerType: PartnerTypeValuesType;
  }
) => {
  AuthoringPartnerAPIUtils.createNewPartner(name, shortName, abbrName, partnerType).then((response) => {
    const { id } = response.elements[0];

    // poll if the new partner has been cached on the backend or not
    const intervalId = setInterval(() => {
      getMyAdmins(id)
        .then((pollResponse) => {
          if (pollResponse.elements.length > 0) {
            window.clearInterval(intervalId);
            redirect.setLocation(`/teach-partner/${shortName}/settings/institution-assets`);
          }
        })
        .done();
    }, 10000);
  });
};

export const getCurrentPartner = (actionContext: $TSFixMe, { partnerId }: $TSFixMe) => {
  AuthoringPartnerAPIUtils.getPartnerForAuthoring(partnerId).then((response) => {
    actionContext.dispatch('RECEIVE_CURRENT_PARTNER', response.elements[0]);
  });
};

export const updateCurrentPartner = (actionContext: $TSFixMe, partner: $TSFixMe) => {
  actionContext.dispatch('UPDATE_CURRENT_PARTNER', partner);
};

export const saveCurrentPartner = (actionContext: $TSFixMe, partner: $TSFixMe) => {
  actionContext.dispatch('SAVE_PARTNER_START');

  AuthoringPartnerAPIUtils.updatePartner(partner)
    .then((response) => {
      actionContext.dispatch('SAVE_PARTNER_SUCCESS');
    })
    .catch((error) => {
      actionContext.dispatch('SAVE_PARTNER_FAILED');
    });
};
